// extracted by mini-css-extract-plugin
export var column = "_t1-0";
export var divider = "_t1-2";
export var timePicker = "_t1-1";